import { Stepper } from "@/components/core/stepper";
import { useEffect, useState } from "react";

export default function CaseStages({
	value,
	stages,
	activities,
}: {
	value: string;
	stages: {
		label: string;
		value: string;
	}[];
	activities: (stage: string) => React.ReactNode;
}) {
	const queryParams = new URLSearchParams(window.location.search);
	const urlStage = queryParams.get("stage");

	const [stage, setStage] = useState(value);
	useEffect(() => {
		if (urlStage !== stage) {
			setStage(urlStage);
		}
		if (!urlStage) {
			setStage(value);
		}
	}, [urlStage]);

	return (
		<Stepper
			value={stage}
			onChange={(value) => {
				setStage(value);
			}}
			steps={stages}
			navigation={false}
		>
			{activities(stage)}
		</Stepper>
	);
}
